import { render, staticRenderFns } from "./vFormHEADLINE.vue?vue&type=template&id=4b5dc56a&scoped=true&"
import script from "./vFormHEADLINE.vue?vue&type=script&lang=js&"
export * from "./vFormHEADLINE.vue?vue&type=script&lang=js&"
import style0 from "./vFormHEADLINE.vue?vue&type=style&index=0&id=4b5dc56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5dc56a",
  null
  
)

export default component.exports